import React, {Component} from 'react';
import {
  Row,
  Col,
  Panel,
  PanelBody,
  PanelContainer,
  PanelHeader,
  Grid,
  Icon,
  Well,
  Table,
  ButtonToolbar,
  ButtonGroup,
  Button,
} from '@sketchpixy/rubix';
import Moment from 'moment';
import {extendMoment} from 'moment-range';
import _ from 'lodash';

import {getSubscriptionStatus} from '../../api/api';
import {routeUrl} from '../routeUrl';

const moment = extendMoment(Moment);
const DATA_OPTIONS = [
    'day',
    'week',
    'month',
];

let scChart = null;
let chartConfig;

export default class Status extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: moment().subtract(6, 'months'),
      endDate: moment(),
      data: [],
      count: {
        already: 0,
        new: 0,
        cancel: 0,
        total: 0,
      },
      ratio: {
        num: 0,
        icon: 'icon-fontello-minus-1',
        iconCollection: {
          up: 'icon-feather-arrow-up',
          down: 'icon-feather-arrow-down',
          equal: 'icon-fontello-minus-1',
        },
        iconColor: 'fg-deepred',
        iconColorCollection: {
          up: 'fg-deepred',
          down: 'fg-blue',
          equal: 'fg-black',
        },
      },
      dataOption: DATA_OPTIONS[0],
    };

    this.dataOptionChanged = this.dataOptionChanged.bind(this);

  }

  initDatePicker() {
    let start = moment().subtract(6, 'months');
    let end = moment();

    $('#datepicker').daterangepicker({
      startDate: start,
      endDate: end,
      alwaysShowCalendars: true,
      minDate: moment('2017-01-11'),
      maxDate: moment(),
      ranges: {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'Last 6 Months': [moment().subtract(6, 'months'), moment()],
        'Last 1 Year': [moment().subtract(1, 'year'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
      },
    }, (start, end) => {
      $('#datepicker span').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
      this.setState({
        startDate: start,
        endDate: end,
      }, () => {
        this.updateChart(this.state.dataOption);
      });
    });

    $('#datepicker span').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));

  }

  componentDidMount() {
    this.initDatePicker();

    getSubscriptionStatus((err, result) => {
      if (err) {
        this.props.router.push(routeUrl.unAuth);
      } else {
        this.initChart();
        this.setState({data: result}, () => {
          this.updateChart('day');
        });
      }
    });
  }

  getLabels = (start, end, mode) => {
    const s = moment(start).format('YYYY-MM-DD');
    const e = moment(end).format('YYYY-MM-DD');
    const range = moment.range(e, s);
    for (let month of range.by('month')) {
      month.format('YYYY-MM-DD');
    }

    const days = Array.from(range.by(mode));
    return days.map(m => m.format('YYYY-MM-DD'));
  };

  initChart = () => {
    const ctx = $('#line-chart').get(0).getContext('2d');

    const d = {
      labels: [0],
      datasets: [
        {
          label: 'Total',
          type: 'line',
          backgroundColor: 'rgba(151,187,205,0)',
          borderColor: 'rgb(0, 84, 169)',
          pointColor: 'rgba(220,220,220,1)',
          pointStrokeColor: '#fff',
          pointHighlightFill: '#fff',
          pointHighlightStroke: 'rgba(220,220,220,1)',
          data: [0],
        },
        {
          label: 'New',
          type: 'line',
          backgroundColor: 'rgba(151,187,205,0)',
          borderColor: 'green',
          pointColor: 'rgba(151,187,205,1)',
          pointStrokeColor: '#fff',
          pointHighlightFill: '#fff',
          pointHighlightStroke: 'rgba(151,187,205,1)',
          data: [0],
        },
        {
          label: 'Cancel',
          type: 'line',
          backgroundColor: 'rgba(151,187,205,0)',
          borderColor: 'rgb(185, 29, 71)',
          pointColor: 'rgba(151,187,205,1)',
          pointStrokeColor: '#fff',
          pointHighlightFill: '#fff',
          pointHighlightStroke: 'rgba(151,187,205,1)',
          data: [0],
        },
      ],
    };

    chartConfig = {
      type: 'line',
      data: d,
      options: {
        responsive: true,
        title: {
          display: true,
          text: 'Subscription Status of Patients',
        },
        legend: {
          display: true,
          position: 'right',
        },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        scales: {
          xAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Day',
              },
            }],
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Number',
              },
            }],
        },
        hover: {
          mode: 'nearest',
          intersect: true,
        },
      },
    };

    scChart = new Chart(ctx, chartConfig);
  };

  changeData(mode) {
    let startDate = moment(this.state.startDate).valueOf();
    let endDate = moment(this.state.endDate).valueOf();

    //시작날짜와 끝날짜 사이의 날짜값을 가져옴. 모드 : 일/주/월/년 단위
    let labels = this.getLabels(endDate, startDate, mode);

    //시작날짜와 끝날짜 사이의 값만 필터링
    let newData;
    const data = this.state.data;
    newData = _.filter(data, (obj) => {
      let d = moment(obj.date).valueOf();
      if (d <= endDate && d >= startDate) {
        return obj;
      }
    });

    //검색된 데이터가 한개도 없다면.. 에러피하기
    if (newData.length === 0) {
      let lastIndex = data.length - 1;
      newData.push({
        base: data[lastIndex].base,
        cancel: 0,
        new: 0,
        total: data[lastIndex].total,
      });
    }

    //생성된 날짜에 따라 모든 데이터를 0으로 초기화
    let i = 0, l = labels.length;
    let total = [], newly = [], cancel = [], base = [];
    let firstBaseValue = newData[0].base;
    while (i < l) {
      total.push(firstBaseValue);
      newly.push(0);
      cancel.push(0);
      base.push(firstBaseValue);
      i++;
    }

    for (let i = 0, l = labels.length; i < l; i++) {
      if (i + 1 > l) break;

      const a = moment(labels[i]).valueOf();
      const b = moment(labels[i + 1]).valueOf();

      for (let j = 0, k = newData.length; j < k; j++) {
        const realDate = moment(newData[j].date).valueOf();
        if (realDate >= a && realDate < b) {
          if (base[i] === 0 && i !== 0) {
            base[i] = newData[j].base;
          }
          newly[i] += newData[j].new;
          cancel[i] += newData[j].cancel;
          total[i] = newData[j].base + newData[j].new - newData[j].cancel;

          for (let m = i, n = base.length; m < n; m++) {

            if (base[m + 1] !== undefined) {
              base[m + 1] = total[i];
            }

            total[m] = total[i];
          }

        }
      }
    }

    if (mode !== 'day') {
      labels = this.changeLabels(labels);
    }

    //x축 표시 레이블 변경
    if (chartConfig) {
      chartConfig.options.scales.xAxes[0].scaleLabel.labelString = mode.charAt(0).toUpperCase() + mode.slice(1);
    }

    this.setRatio(total, newly, cancel, base);

    return {
      labels,
      total,
      newly,
      cancel,
    };

  }

  changeLabels(labels) {
    return labels.map((label, index) => {
      if (!labels[index + 1]) {
        return `${label} ~ ${moment(this.state.endDate).format('YYYY-MM-DD')}`;
      }
      else {
        return `${label} ~ ${moment(labels[index + 1]).subtract(1, 'days').format('YYYY-MM-DD')}`;
      }
    });
  }

  getSum(array) {
    let sum = 0;
    array.forEach((data) => {
      sum += data;
    });
    return sum;
  }

  setRatio(total, newly, cancel, base) {
    let newCount = this.getSum(newly);
    let cancelCount = this.getSum(cancel);
    // get ratio and count for duration

    let t = total[total.length - 1], b = base[0];
    let ratio = Math.floor(((t / b) - 1) * 100);
    let ratioIcon, color;
    if (ratio === 0) {
      ratioIcon = this.state.ratio.iconCollection.equal;
      color = this.state.ratio.iconColorCollection.equal;
    }
    else if (ratio > 0) {
      ratioIcon = this.state.ratio.iconCollection.up;
      color = this.state.ratio.iconColorCollection.up;
    }
    else {
      ratioIcon = this.state.ratio.iconCollection.down;
      color = this.state.ratio.iconColorCollection.down;
    }

    this.setState({
      count: {
        already: base[0],
        total: total[total.length - 1],
        new: newCount,
        cancel: cancelCount,
      },
      ratio: {
        ...this.state.ratio,
        num: ratio,
        icon: ratioIcon,
        iconColor: color,
      },
    });

  }

  updateChart(mode) {
    let dataObj = this.changeData(mode);
    chartConfig.data.labels = dataObj.labels;
    chartConfig.data.datasets[0].data = dataObj.total;
    chartConfig.data.datasets[1].data = dataObj.newly;
    chartConfig.data.datasets[2].data = dataObj.cancel;
    scChart.update();
  }

  dataOptionChanged(value) {
    this.setState({dataOption: value});
    this.updateChart(value);
  }

  render() {
    return (
        <div>
          <Row>
            <Col sm={12}>
              <PanelContainer controls={false}>
                <Panel>
                  <PanelHeader className="bg-pinkishred fg-white">
                    <Grid>
                      <Row>
                        <Col xs={12}>
                          <h3>
                            <Icon glyph="icon-fontello-chart-line" />
                            &nbsp; Subscription status
                          </h3>
                        </Col>
                      </Row>
                    </Grid>
                  </PanelHeader>
                  <PanelBody style={{padding: 25}}>
                    <Well>
                      <div
                          id="datepicker"
                          className="pull-right"
                          style={{
                            background: '#fff',
                            cursor: 'pointer',
                            padding: '5px 10px',
                            border: '1px solid #ccc',
                          }}
                      >
                        <i className="glyphicon glyphicon-calendar fa fa-calendar" />
                        &nbsp;
                        <span />
                        <b className="caret" />
                      </div>
                      <div>
                        <ButtonToolbar style={{width: '30%'}}>
                          <ButtonGroup>
                            {
                              DATA_OPTIONS.map(dataOption => (
                                  <Button
                                      key={dataOption}
                                      bsStyle="pinkishred"
                                      outlined={this.state.dataOption === dataOption}
                                      onClick={() => this.dataOptionChanged(dataOption)}>
                                    {dataOption}
                                  </Button>
                              ))
                            }
                          </ButtonGroup>
                        </ButtonToolbar>
                      </div>
                    </Well>
                    <div id="line-chart-wrapper" style={{width: '100%', overflow: 'auto'}}>
                      <canvas id="line-chart" height="75" width="250" name="Line Chart" />
                    </div>
                  </PanelBody>
                </Panel>
              </PanelContainer>
              <PanelContainer controls={false}>
                <Panel>
                  <PanelBody>
                    <Grid>
                      <Row>
                        <Col xs={4}>
                          <div>
                            <div>
                              Change for date range :&nbsp;
                              <span className={this.state.ratio.iconColor}>
                                <Icon glyph={this.state.ratio.icon} />
                                {this.state.ratio.num} %
                              </span>
                            </div>
                            <Table bordered>
                              <thead>
                              <tr>
                                <th>Already exists</th>
                                <th>New</th>
                                <th>Cancel</th>
                                <th>Total</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr>
                                <td>{this.state.count.already}</td>
                                <td>{this.state.count.new}</td>
                                <td>{this.state.count.cancel}</td>
                                <td>{this.state.count.total}</td>
                              </tr>
                              </tbody>
                            </Table>
                          </div>
                        </Col>
                      </Row>
                    </Grid>
                  </PanelBody>
                </Panel>
              </PanelContainer>
            </Col>
          </Row>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/patient/Status.js